import type { Locale } from '@lista/shared-types';
import ar from './ar.json';
import en from './en.json';

/**
 * One catalog for web and mobile (CLAUDE.md rule 7: every string in en and ar).
 * Keys use i18next plural suffixes; Arabic has _zero/_one/_two/_few/_many/_other.
 */
export const resources = {
  en: { translation: en },
  ar: { translation: ar },
} as const;

export type Catalog = typeof en;

export const isRtl = (locale: string) => locale === 'ar';

export const toLocale = (tag: string | null | undefined): Locale =>
  tag?.toLowerCase().startsWith('ar') ? 'ar' : 'en';

export { ar, en };
